/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["midnat", "om morgenen", "om formiddagen", "om eftermiddagen", "om aftenen", "om natten"], u, u], [["midnat", "morgen", "formiddag", "eftermiddag", "aften", "nat"], u, u], ["00:00", ["05:00", "10:00"], ["10:00", "12:00"], ["12:00", "18:00"], ["18:00", "24:00"], ["00:00", "05:00"]]];
